import React, { useState, useEffect } from "react";
import {
    getEmailTempaltesforCollection,
    getSmsTempaltesforCollection,
    getWhatsappTempaltesforCollection,
    getCommunicationPreiviwTempalteByTemplateId,
    sendDirectTemplateUsingTempalteidAndType,
    getRecoveryAllcommentList,
    getcommunicationListByLoanId,
    SaveOrUpdatecommentRecoveryByData,
    getRecoveryCommentsByEmiId,
    saveDirectTemplateWithContextUsingTempalteid,
    getCommunicationPreiviwTempalteByTemplateIdWithBody
} from "../AdminActionCreator.component";
import Popup from "../../../presentationals/Popup/Popup.component";
import Loader from "../../../presentationals/Loader/Loader.component";
import Pagination from "@mui/material/Pagination";
import { ABHICASH_ONLY, CHECK_COMPANY_TENANT, CREDFIN_LIKE } from "../../../../layouts/MainTenantconfig";

const itemsPerPage = 10;
const generateTimeOptions = () => {
    const times = [];
    const start = new Date();
    start.setHours(8, 0, 0, 0); // 8:00 AM
    const end = new Date();
    end.setHours(18, 0, 0, 0); // 6:00 PM

    while (start <= end) {
        const hours = start.getHours();
        const minutes = start.getMinutes();
        const formattedTime = start.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });
        times.push(formattedTime);
        start.setMinutes(minutes + 15); // +15 minutes
    }

    return times;
};

export default function RecoveryCommunicationNew({
    dataForCommunication,
    admin,
    collectionType,
    pagetype,
}) {
    const [loader, setLoader] = useState(false);
    const [commType, setcommType] = useState("mail");
    const [templateList, setTemplateList] = useState([]);
    const [selectedTemplate, setSelectedTemplateId] = useState({});
    const [previewData, setPreviewData] = useState("");
    const [popup, setpopup] = useState({ show: false, popupStatus: "" });
    const [AllcommentList, setAllcommentList] = useState([]);
    const [commentList, setcommentList] = useState([]);
    const [PaginatedData, setPaginatedData] = useState([]);
    const [commentPopup, setcommentPopup] = useState(false);
    const [currentPage, setcurrentPage] = useState(1);
    const [commentPayload, setcommentPayload] = useState({
        comment: "",
        date: "",
        remark: "",
    });
    const [openPopup, setOpenPopup] = useState(false);
    const [templateObj, setTemplateObj] = useState({});
    const templateFields = {
        1: [
            { key: "amount_numeric", label: "Amount (Number)" },
            { key: "amount_words", label: "Amount (In Words)" },
            { key: "installment1_amount", label: "Installment 1 Amount" },
            { key: "installment1_date", label: "Installment 1 Date" },
            { key: "installment2_amount", label: "Installment 2 Amount" },
            { key: "installment2_date", label: "Installment 2 Date" },
            { key: "installment3_amount", label: "Installment 3 Amount" },
            { key: "installment3_date", label: "Installment 3 Date" },
        ],
        4: [
            { key: "amountNumeric", label: "Amount (Number)" },
            { key: "amountWords", label: "Amount (In Words)" },
            { key: "settlementDate", label: "Settlement Date" },
        ],
        2: [
            { key: "settlementAmount", label: "Settlement Amount" },
            { key: "settlementDate", label: "Settlement Date" },
        ],
    };

    const fields = CHECK_COMPANY_TENANT(ABHICASH_ONLY) ?  templateFields[selectedTemplate?.emailId] || [] : [];

    useEffect(() => {
        setcommType(pagetype);
        if (pagetype == "msg") {
            getSmsTempaltesforCollectionFn();
        }
        if (pagetype == "mail") {
            getEmailTempaltesforCollectionFn();
        }
        if (pagetype == "Whatsapp") {
            getWhatsappTempaltesforCollectionFn();
        }
        if (pagetype == "comment") {
            getRecoveryAllcommentListFn();
            getcommunicationListByLoanIdFn();
        }
        setPreviewData("");
        setSelectedTemplateId({});
    }, [pagetype]);

    const getRecoveryAllcommentListFn = () => {
        setLoader(true);
        getRecoveryAllcommentList((callback) => {
            setLoader(false);
            console.log("call", callback);
            if (callback?.length > 0) {
                setAllcommentList(callback);
            } else {
                setAllcommentList([]);
            }
        });
    };
    const getcommunicationListByLoanIdFn = () => {
        setLoader(true);
        // getcommunicationListByLoanId(dataForCommunication?.loanId, callback => {
        //     setLoader(false)
        //     console.log("call", callback)
        //     if (callback?.status == 200 && callback?.data?.length > 0) {
        //         setcommentList(callback?.data)
        //         paginate(callback?.data,1)
        //         setcurrentPage(1)
        //     } else {
        //         setcommentList([])
        //         setPaginatedData([])
        //     }
        // })
        getRecoveryCommentsByEmiId(
            dataForCommunication?.loanId,
            dataForCommunication?.emidId,
            (callback) => {
                setLoader(false);
                console.log("call", callback);
                if (callback?.status == 200 && callback?.data?.length > 0) {
                    setcommentList(callback?.data);
                    paginate(callback?.data, 1);
                    setcurrentPage(1);
                } else {
                    setcommentList([]);
                    setPaginatedData([]);
                }
            },
        );
    };
    const getEmailTempaltesforCollectionFn = () => {
        setLoader(true);
        getEmailTempaltesforCollection((callback) => {
            setLoader(false);
            console.log("call", callback);
            if (callback?.status == 200 && callback?.data?.length > 0) {
                setTemplateList(callback?.data);
            } else {
                setTemplateList([]);
            }
        });
    };
    const getSmsTempaltesforCollectionFn = () => {
        setLoader(true);
        getSmsTempaltesforCollection((callback) => {
            setLoader(false);
            console.log("call", callback);
            if (callback?.status == 200 && callback?.data?.length > 0) {
                setTemplateList(callback?.data);
            } else {
                setTemplateList([]);
            }
        });
    };
    const getWhatsappTempaltesforCollectionFn = () => {
        setLoader(true);
        getWhatsappTempaltesforCollection((callback) => {
            setLoader(false);
            console.log("call", callback?.data);
            if (callback?.status == 200 && callback?.data?.length > 0) {
                setTemplateList(callback?.data);
            } else {
                setTemplateList([]);
            }
        });
    };

    const msgTempleteClick = (data) => {
        console.log("fguvhjf", data);
        if (pagetype === "mail" && [1,2, 4].includes(data?.emailId) && CHECK_COMPANY_TENANT(ABHICASH_ONLY)) {
            setOpenPopup(true);
            setSelectedTemplateId(data);
            return;
        }

        setSelectedTemplateId(data);
        const obj = {
            templateId:
                pagetype == "msg"
                    ? data?.smsId
                    : pagetype == "mail"
                        ? data?.emailId
                        : pagetype == "Whatsapp"
                            ? data?.whatsappId
                            : "",
            commType:
                pagetype == "msg"
                    ? "SMS"
                    : pagetype == "mail"
                        ? "EMAIL"
                        : pagetype == "Whatsapp"
                            ? "WHATSAPP"
                            : "",
            userId: dataForCommunication?.userId,
        };
        setLoader(true);
        getCommunicationPreiviwTempalteByTemplateId(
            obj?.templateId,
            obj?.commType,
            obj?.userId,
            (callback) => {
                setLoader(false);
                console.log("ca", callback);
                if (callback?.status == 200) {
                    setPreviewData(callback?.data);
                } else {
                    setPreviewData("");
                }
            },
        );
    };

    const handleSendMsg = () => {
        const obj = {
            templateId:
                pagetype == "msg"
                    ? selectedTemplate?.smsId
                    : pagetype == "mail"
                        ? selectedTemplate?.emailId
                        : pagetype == "Whatsapp"
                            ? selectedTemplate?.whatsappId
                            : "",
            commType:
                pagetype == "msg"
                    ? "SMS"
                    : pagetype == "mail"
                        ? "EMAIL"
                        : pagetype == "Whatsapp"
                            ? "WHATSAPP"
                            : "",
            userId: dataForCommunication?.userId,
        };
        console.log("obj", obj)
        setLoader(true);
        if (obj.templateId != "1" && obj.templateId != "2" && obj.templateId != "4" && CHECK_COMPANY_TENANT(ABHICASH_ONLY)) {
            
            sendDirectTemplateUsingTempalteidAndType(
                obj?.templateId,
                obj?.commType,
                obj.userId,
                (callback) => {
                    setLoader(false);
                    if (callback == "success") {
                        setpopup({
                            show: true,
                            popupStatus:
                                pagetype == "msg"
                                    ? "Message Sent Successfully"
                                    : pagetype == "mail"
                                        ? "Mail Sent Successfully"
                                        : pagetype == "Whatsapp"
                                            ? "Message Sent Successfully"
                                            : "",
                        });
                        setPreviewData("");
                        setSelectedTemplateId({});
                    } else {
                        setpopup({
                            show: true,
                            popupStatus: "Please Try Again",
                        });
                    }
                    removePopup();
                },
            );
        } else {
            const payload = fields.reduce((acc, field) => {
                acc[field.key] = field.key.toLowerCase().includes("date")
                    ? formatDate(templateObj?.[field.key])
                    : templateObj?.[field.key] || "";

                return acc;
            }, {});

            saveDirectTemplateWithContextUsingTempalteid(
                obj?.templateId,
                obj?.commType,
                obj.userId,
                payload,
                (callback) => {
                    setLoader(false);
                    console.log("callback", callback);
                    if (callback == "success") {

                        setpopup({ show: true, popupStatus: "Mail Send Successfully" });
                    } else {
                        setpopup({ show: true, popupStatus: "Error Sending Mail" });
                    }
                    removePopup();

                },
            );
        }


    };

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" });
    };

    const removePopup = () => {
        setTimeout(() => {
            closePopup();
        }, 5000);
    };

    const handlecommentPopup = (value) => {
        setcommentPopup(value);
        setcommentPayload({
            comment: "",
            date: "",
            remark: "",
        });
    };

    const handleSavecomment = () => {
        console.log("dataForCommunication", dataForCommunication);
        const data = {
            loanId: dataForCommunication?.loanId,
            comment: commentPayload?.comment,
            remark:
                commentPayload?.comment == "Will pay in a few days" ||
                    commentPayload?.comment == "Promised to Pay on" ||
                    commentPayload?.comment == "Will Inform to pay"
                    ? commentPayload?.date + "T" + commentPayload?.remark
                    : commentPayload?.remark,
            commentBy: admin?.emailId,
            emiId: dataForCommunication?.emiId || "",
        };

        setLoader(true);
        SaveOrUpdatecommentRecoveryByData(data, (callback) => {
            setLoader(false);
            if (callback == "success") {
                setpopup({ show: true, popupStatus: "Comment Saved Successfully" });
            } else {
                setpopup({ show: true, popupStatus: "Error Saving Comment" });
            }
            handlecommentPopup(false);
            getcommunicationListByLoanIdFn();
            removePopup();
        });
    };

    const handlePagePagination = (event, value) => {
        setcurrentPage(value);
        paginate(commentList, value);
    };

    const paginate = (data, page) => {
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const sliced = data.slice(startIndex, endIndex);
        setPaginatedData(sliced);
    };

    const handleTemplateObjChnage = (e, key) => {
        setTemplateObj((prev) => ({
            ...prev,
            [key]: e.target.value,
        }));
    };

    const formatDate = (date) => {
        if (!date) return "";
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
    };

    const handleClosePopup = () => {
        setOpenPopup(false);
        setSelectedTemplateId({});
        setTemplateObj({});
    };

    const templateNotificationHanlder = () => {
        const templateId =
            pagetype === "msg"
                ? selectedTemplate?.smsId
                : pagetype === "mail"
                    ? selectedTemplate?.emailId
                    : pagetype === "Whatsapp"
                        ? selectedTemplate?.whatsappId
                        : "";

        const commType =
            pagetype === "msg"
                ? "SMS"
                : pagetype === "mail"
                    ? "EMAIL"
                    : pagetype === "Whatsapp"
                        ? "WHATSAPP"
                        : "";

        const userId = dataForCommunication?.userId;

        const payload = fields.reduce((acc, field) => {
            acc[field.key] = field.key.toLowerCase().includes("date")
                ? formatDate(templateObj?.[field.key])
                : templateObj?.[field.key] || "";

            return acc;
        }, {});


        setLoader(true);

        getCommunicationPreiviwTempalteByTemplateIdWithBody(
            templateId,
            commType,
            userId,
            payload,
            (previewCallback) => {
                setLoader(false);
                setOpenPopup(false);
                if (previewCallback?.status === 200) {
                    setPreviewData(previewCallback?.data);
                } else {
                    setPreviewData("");
                }
            },
        );


    };

    useEffect(() => {
        if (openPopup) {
            setTemplateObj({});
        }
    }, [openPopup]);

    const isTemplateValid = () => {
        if (!fields || fields.length === 0) return true;

        return fields.every((field) => {
            const value = templateObj?.[field.key];


            if (!value || value.toString().trim() === "") return false;


            return true;
        });
    };

    return (
        <>
            <div className="container-fluid">
                {loader ? <Loader /> : ""}
                {popup?.show ? (
                    <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                ) : (
                    ""
                )}
                {!(pagetype == "comment") ? (
                    <div className="row">
                        <div className="col-sm-5 col-xs-12">
                            <h3 className=" text-center blue-text">Templates</h3>
                            {collectionType == "recovery" ? (
                                <ol>
                                    {templateList && templateList?.length > 0
                                        ? templateList?.map((value, id) => {
                                            return (
                                                <li
                                                    key={id}
                                                    onClick={() => msgTempleteClick(value)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="communicationMsg"
                                                        checked={
                                                            pagetype == "msg"
                                                                ? value?.smsId === selectedTemplate?.smsId
                                                                    ? true
                                                                    : false
                                                                : pagetype == "mail"
                                                                    ? value?.emailId ==
                                                                        selectedTemplate?.emailId
                                                                        ? true
                                                                        : false
                                                                    : pagetype == "Whatsapp"
                                                                        ? value?.whatsappId ==
                                                                            selectedTemplate?.whatsappId
                                                                            ? true
                                                                            : false
                                                                        : false
                                                        }
                                                        onClick={(e) => msgTempleteClick(value)}
                                                        style={{
                                                            display: "inline-block",
                                                            height: "10px",
                                                        }}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <span>
                                                        <strong>
                                                            {pagetype == "msg"
                                                                ? value?.messageDescription
                                                                : pagetype == "mail"
                                                                    ? value?.emailSubject
                                                                    : pagetype == "Whatsapp"
                                                                        ? value?.whatsappSubject
                                                                        : ""}
                                                        </strong>
                                                    </span>
                                                </li>
                                            );
                                        })
                                        : ""}
                                </ol>
                            ) : (
                                ""
                            )}
                        </div>

                        {previewData !== "" ? (
                            <div className="col-sm-7 col-xs-12">
                                <div className="col-xs-12">
                                    {pagetype == "mail" ? (
                                        <div
                                            style={{
                                                height: "300px",
                                                overflowY: "auto",
                                                borderRadius: "6px",
                                                padding: "10px",
                                                boxShadow: "3px 3px 8px 3px #dadada",
                                            }}
                                        >
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: previewData,
                                                }}
                                            ></div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    {pagetype == "msg" || pagetype == "Whatsapp" ? (
                                        <div
                                            style={{
                                                height: "300px",
                                                overflowY: "auto",
                                                borderRadius: "6px",
                                                padding: "10px",
                                                boxShadow: "3px 3px 8px 3px #dadada",
                                            }}
                                        >
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: previewData,
                                                }}
                                            ></div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>

                                <div className="col-xs-12">
                                    <button
                                        className="profile-save-btn center-block"
                                        onClick={(e) => handleSendMsg()}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-xs-12" style={{ marginTop: "30px" }}>
                            <div>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => handlecommentPopup(true)}
                                >
                                    Add Comment
                                </button>
                            </div>
                            <div className="phocket-table-new">
                                <table className="text-center ">
                                    <thead>
                                        <tr>
                                            <th>Comment By</th>
                                            <th>Comment</th>
                                            <th>Remark</th>
                                            <th>Added On</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {PaginatedData?.length > 0
                                            ? PaginatedData?.map((recData, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{recData?.commentBy ?? ""}</td>
                                                        <td>{recData?.comment ?? ""}</td>
                                                        <td>{recData?.remark ?? ""}</td>
                                                        <td>{recData?.addedAt ?? ""}</td>
                                                    </tr>
                                                );
                                            })
                                            : ""}
                                    </tbody>
                                </table>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        margin: "20px 0",
                                    }}
                                >
                                    <Pagination
                                        color="primary"
                                        count={Math.ceil(commentList?.length / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePagePagination}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {commentPopup ? (
                <div className="background-blur">
                    <div
                        className="popup-main small-popup container-fluid max-width-500px dbl-border "
                        style={{ padding: "20px", borderRadius: "10px", top: "20%" }}
                    >
                        <i
                            onClick={() => handlecommentPopup(false)}
                            style={{
                                float: "right",
                                marginTop: "-18px",
                                marginRight: "-17px",
                                fontSize: "20px",
                                color: "red",
                            }}
                            className="fa fa-times-circle"
                        ></i>
                        <div>
                            <h3 className="text-center">Add Comment</h3>
                        </div>
                        <div
                            style={{ display: "flex", gap: "10px", justifyContent: "center" }}
                        >
                            <div style={{ textAlign: "left" }}>
                                <label htmlFor="">Select Comment</label>
                                <select
                                    className="form-control"
                                    value={commentPayload?.comment}
                                    onChange={(e) =>
                                        setcommentPayload({
                                            remark: "",
                                            comment: e.target.value,
                                            date: "",
                                        })
                                    }
                                    style={{
                                        width:
                                            commentPayload?.comment == "Will pay today" ||
                                                commentPayload?.comment ==
                                                "Will pay today - Part payment" ||
                                                commentPayload?.comment == "Will pay tomorrow" ||
                                                commentPayload?.comment == "Will pay in a few days" ||
                                                commentPayload?.comment == "Promised to Pay on" ||
                                                commentPayload?.comment == "Will Inform to pay"
                                                ? "70%"
                                                : "100%",
                                    }}
                                >
                                    <option value="">Select</option>
                                    {AllcommentList && AllcommentList?.length > 0
                                        ? AllcommentList?.map((v) => {
                                            return <option value={v}>{v}</option>;
                                        })
                                        : ""}
                                </select>
                            </div>
                            {/* {
                                    commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" || commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ?
                                        <div style={{ textAlign: 'left' }}>
                                            <label htmlFor="">{commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" ? "Time" : "Date & Time"}</label>
                                            <input
                                                className='form-control'
                                                type={commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" ? "time" : 'datetime-local'}
                                                value={commentPayload?.remark} onChange={(e) => setcommentPayload((prev) => ({ ...prev, "remark": e.target.value }))} style={{ width: '100%' }} />
                                        </div>
                                        : ''} */}
                            {commentPayload?.comment == "Will pay in a few days" ||
                                commentPayload?.comment == "Promised to Pay on" ||
                                commentPayload?.comment == "Will Inform to pay" ? (
                                <div style={{ textAlign: "left" }}>
                                    <label htmlFor="">Date</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        value={commentPayload?.date}
                                        onChange={(e) =>
                                            setcommentPayload((prev) => ({
                                                ...prev,
                                                date: e.target.value,
                                            }))
                                        }
                                        style={{ width: "100%" }}
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                            {commentPayload?.comment == "Will pay today" ||
                                commentPayload?.comment == "Will pay today - Part payment" ||
                                commentPayload?.comment == "Will pay tomorrow" ||
                                commentPayload?.comment == "Will pay in a few days" ||
                                commentPayload?.comment == "Promised to Pay on" ||
                                commentPayload?.comment == "Will Inform to pay" ? (
                                <div style={{ textAlign: "left" }}>
                                    <label htmlFor="">Time</label>
                                    <select
                                        className="form-control"
                                        value={commentPayload?.remark}
                                        onChange={(e) =>
                                            setcommentPayload((prev) => ({
                                                ...prev,
                                                remark: e.target.value,
                                            }))
                                        }
                                        style={{ width: "100%" }}
                                    >
                                        <option value="">Select</option>
                                        {generateTimeOptions()?.map((time, index) => (
                                            <option key={index} value={time}>
                                                {time}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            ) : (
                                ""
                            )}
                            {commentPayload?.comment == "Language Barrier" ? (
                                <div style={{ textAlign: "left" }}>
                                    <label>Language</label>
                                    <select
                                        className="form-control"
                                        value={commentPayload?.remark}
                                        onChange={(e) =>
                                            setcommentPayload((prev) => ({
                                                ...prev,
                                                remark: e.target.value,
                                            }))
                                        }
                                        style={{ width: "100%" }}
                                    >
                                        <option value={""}>Select</option>
                                        <option value={"Hindi"}>Hindi</option>
                                        <option value={"English"}>English</option>
                                        <option value={"Bengali"}>Bengali</option>
                                        <option value={"Odia"}>Odia</option>
                                        <option value={"Tamil"}>Tamil</option>
                                        <option value={"Telugu"}>Telugu</option>
                                        <option value={"Kannada"}>Kannada</option>
                                    </select>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="text-center" style={{ marginTop: "15px" }}>
                            <button
                                className="btn btn-primary"
                                disabled={
                                    commentPayload?.comment == "" ||
                                        commentPayload?.comment == null ||
                                        commentPayload?.comment == undefined
                                        ? true
                                        : false
                                }
                                onClick={() => handleSavecomment()}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}

            {openPopup ? (
                <div className="background-blur">
                    <div
                        className="popup-main small-popup container-fluid max-width-500px dbl-border "
                        style={{ padding: "20px", borderRadius: "10px" }}
                    >
                        <i
                            onClick={handleClosePopup}
                            style={{
                                float: "right",
                                marginTop: "-18px",
                                marginRight: "-17px",
                                fontSize: "20px",
                                color: "red",
                            }}
                            className="fa fa-times-circle"
                        ></i>
                        <div className="row from-group">
                            <div className="col-xs-12" style={{ padding: "10px" }}>
                                <h4
                                    className="text-center"
                                    style={{ marginBottom: "10px", marginTop: "10px" }}
                                >
                                    Email Template
                                </h4>
                            </div>
                        </div>
                        <div className="row form-group">
                           
                            {fields?.map((field, index) => (
                                <div
                                    key={index}
                                    className="col-xs-4 col-md-4 col-sm-6"
                                    style={{ marginTop: "15px" }}
                                >
                                    <label>{field.label}</label>

                                    <input
                                        className="form-control"
                                        placeholder={`Enter ${field.label}`}
                                        type={
                                            field.key.toLowerCase().includes("date") ? "date" : "text"
                                        }
                                        value={templateObj?.[field.key] || ""}
                                        onChange={(e) => handleTemplateObjChnage(e, field.key)}
                                    />
                                </div>
                            ))}
                        </div>

                        <div
                            className="row from-group text-center"
                            style={{ marginTop: "20px" }}
                        >
                            <div className="col-xs-12">
                                <button
                                    className="btn "
                                    disabled={!isTemplateValid()}
                                    onClick={() => templateNotificationHanlder()}
                                    style={{
                                        marginTop: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #D3D9E9",
                                        color: "#fff",
                                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                        background: "#2B78FF",
                                    }}
                                >
                                    Preview
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}
        </>
    );
}
